'use client';

import React from 'react';
import { localPriceText, type LocalRate } from '@/lib/pricing/local-currency';
import { useLocalCurrency } from '@/hooks/useLocalCurrency';

type Props = {
  usd: number;
  /** display: local price only. charge: exact USD charge plus the local estimate. */
  mode?: 'display' | 'charge';
  /** Write $10 rather than $10.00 while the amount is still shown in dollars. */
  wholeDollars?: boolean;
  /** Server-rendered text; when given it is what crawlers and the first paint see. */
  children?: React.ReactNode;
  /** Convert at this rate instead of the visitor's, e.g. an order's shipping-country rate. */
  rate?: LocalRate | null;
};

// A USD amount shown in the visitor's currency. Renders dollars on the server and until the
// visitor's country and rate are known, so markup is identical for crawlers and hydration.
export default function LocalPrice({ usd, mode = 'display', wholeDollars, children, rate: fixedRate }: Props) {
  const visitorRate = useLocalCurrency();
  const rate = fixedRate ?? visitorRate;
  if (!rate) return <>{children ?? localPriceText(usd, null, mode, { wholeDollars })}</>;
  return <>{localPriceText(usd, rate, mode, { wholeDollars })}</>;
}
